import { render, staticRenderFns } from "./trendChart.vue?vue&type=template&id=f84197bc&scoped=true"
import script from "./trendChart.vue?vue&type=script&lang=js"
export * from "./trendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84197bc",
  null
  
)

export default component.exports